import { DropdownItem, SplitButtonDropdown } from '@carboncopyco/ui';

export interface SaveButtonProps {
  disabled?: boolean;
  onClick: (shouldRefresh?: boolean) => void;
}

export const SaveButton = ({ onClick, disabled }: SaveButtonProps) => {
  return (
    <SplitButtonDropdown
      label="Save"
      primaryTooltipTitle="Save"
      dropdownTriggerTooltipTitle="Review save options"
      onClick={() => onClick(true)}
      disabled={disabled}
    >
      <DropdownItem
        label="Save without reload"
        onClick={() => onClick(false)}
      />
    </SplitButtonDropdown>
  );
};
